import { Component } from '@angular/core';
import { AdminPharmaciesList } from '../../../../components/admin-dashboard-component/pharmacies/admin-pharmacies-list/admin-pharmacies-list';

@Component({
  selector: 'app-pharmacies-list',
  imports: [AdminPharmaciesList],
  templateUrl: './pharmacies-list.html',
  styleUrl: './pharmacies-list.scss',
})
export class PharmaciesList {}
